<div id="infrastructure">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                    <h4 class="card-title">Herbal Garden</h4>
                        <p class="inner-lead">The institute has a well maintained herbal garden with several species of medicinal plants.</p>
                    </div>
                </div>
            </div>
        </div>